import { BiErrorCircle } from "react-icons/bi";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface SecurityErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const SecurityErrorDialog = ({ isOpen, onClose }: SecurityErrorDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader className="flex flex-col items-center text-center">
          <BiErrorCircle className="mb-4 text-red-500 text-6xl" />
          <DialogTitle className="text-3xl font-semibold mb-3 text-zinc-800 text-center">
            La connexion n'est pas autorisée.
          </DialogTitle>
        </DialogHeader>
        <div className="text-center">
          <p className="text-lg text-zinc-600">
            Veuillez réessayer ou contacter le support si le problème persiste.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SecurityErrorDialog;
